
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuOpen]);

  const isActive = (path: string) => location.pathname === path;

  const handleLinkClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="flex items-center justify-between h-20 sm:h-24 lg:h-28">
          <Link to="/" className="flex items-center cursor-pointer" onClick={handleLinkClick}>
            <img 
              src="https://static.readdy.ai/image/f0ac05ec8022c9fe02f13d58ac304740/0c42e3fe25f5fec8a753f877ff4fb65a.png" 
              alt="Halvera" 
              className="h-16 sm:h-20 lg:h-24"
            />
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-10">
            <Link 
              to="/how-it-works" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/how-it-works') ? 'text-gray-900' : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              How It Works
            </Link>
            <Link 
              to="/for-individuals" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/for-individuals') ? 'text-gray-900' : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              For Individuals
            </Link>
            <Link 
              to="/for-companies" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/for-companies') ? 'text-gray-900' : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              For Companies
            </Link>
            <Link 
              to="/access-levels" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/access-levels') ? 'text-gray-900' : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              Access Levels
            </Link>
            <Link 
              to="/faq" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/faq') ? 'text-gray-900' : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              FAQ
            </Link>
            <Link 
              to="/apply" 
              className="px-7 py-3 bg-red-600 text-white rounded-md text-sm font-semibold hover:bg-red-700 transition-all whitespace-nowrap cursor-pointer"
            >
              Apply for Access
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 top-20 sm:top-24 bg-white z-40 overflow-y-auto">
          <div className="px-4 sm:px-6 py-6 space-y-4">
            <Link 
              to="/how-it-works" 
              onClick={handleLinkClick}
              className={`block py-3 text-base font-medium transition-colors cursor-pointer ${
                isActive('/how-it-works') ? 'text-gray-900' : 'text-gray-700'
              }`}
            >
              How It Works
            </Link>
            <Link 
              to="/for-individuals" 
              onClick={handleLinkClick}
              className={`block py-3 text-base font-medium transition-colors cursor-pointer ${
                isActive('/for-individuals') ? 'text-gray-900' : 'text-gray-700'
              }`}
            >
              For Individuals
            </Link>
            <Link 
              to="/for-companies" 
              onClick={handleLinkClick}
              className={`block py-3 text-base font-medium transition-colors cursor-pointer ${
                isActive('/for-companies') ? 'text-gray-900' : 'text-gray-700'
              }`}
            >
              For Companies
            </Link>
            <Link 
              to="/access-levels" 
              onClick={handleLinkClick}
              className={`block py-3 text-base font-medium transition-colors cursor-pointer ${
                isActive('/access-levels') ? 'text-gray-900' : 'text-gray-700'
              }`}
            >
              Access Levels
            </Link>
            <Link 
              to="/faq" 
              onClick={handleLinkClick}
              className={`block py-3 text-base font-medium transition-colors cursor-pointer ${
                isActive('/faq') ? 'text-gray-900' : 'text-gray-700'
              }`}
            >
              FAQ
            </Link>
            <Link 
              to="/apply" 
              onClick={handleLinkClick}
              className="block w-full px-7 py-3 bg-red-600 text-white rounded-md text-base font-semibold hover:bg-red-700 transition-all text-center cursor-pointer mt-6"
            >
              Apply for Access
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
